module.exports = __webpack_public_path__ + "img/topImg3-1.e49f8b1e.png";